import React from "react";
import {
    FaUserPlus,
    FaSearch,
    FaChartBar,
    FaChalkboardTeacher,
    FaRocket,
    FaClock,
    FaSignInAlt,
    FaInfoCircle,
} from "react-icons/fa";
import "./TeacherMiniSection.css";

const TeacherMiniSection = () => {
    return (
        <section
            className="teacher-section"
            id="teacher"
            aria-labelledby="teacher-heading"
        >
            <div className="teacher-wrapper" data-aos="fade-up">
                {/* Illustration */}
                <div
                    className="teacher-image"
                    data-aos="fade-right"
                    aria-hidden="true"
                >
                    <img src="/images/teacher.png" alt="Teacher guiding students" />
                </div>

                {/* Content */}
                <div className="teacher-content" data-aos="fade-left">
                    <h2 id="teacher-heading" className="teacher-title">
                        <FaChalkboardTeacher /> For Teachers
                    </h2>

                    <p className="teacher-lead">
                        BodhAI helps teachers create tests, assign students, and track
                        performance. Register, upload verification docs (ID / Aadhaar),
                        get admin approval, then access the Teacher Dashboard.
                    </p>

                    {/* Features */}
                    <div className="feature-row" role="list">
                        <article className="feature" role="listitem">
                            <div className="f-icon">
                                <FaUserPlus />
                            </div>
                            <div>
                                <h4>Register</h4>
                                <p>
                                    Quick sign-up with profile and document links (ID & Aadhaar).
                                </p>
                            </div>
                        </article>

                        <article className="feature" role="listitem">
                            <div className="f-icon">
                                <FaSearch />
                            </div>
                            <div>
                                <h4>Verification</h4>
                                <p>
                                    Admin reviews documents. Status → Pending / Approved /
                                    Rejected.
                                </p>
                            </div>
                        </article>

                        <article className="feature" role="listitem">
                            <div className="f-icon">
                                <FaChartBar />
                            </div>
                            <div>
                                <h4>Dashboard</h4>
                                <p>
                                    Once approved, create tests, view analytics, and manage
                                    students.
                                </p>
                            </div>
                        </article>
                    </div>

                    {/* Actions */}
                    <div className="actions">
                        <a
                            href="/teacher-registration"
                            className="btn primary"
                            aria-label="Register as a teacher"
                        >
                            <FaRocket /> Register
                        </a>
                        <a
                            href="/teacher-status"
                            className="btn outline"
                            aria-label="Check application status"
                        >
                            <FaClock /> Check Status
                        </a>
                        <a href="/teacher-login" className="btn ghost" aria-label="Teacher login">
                            <FaSignInAlt /> Login
                        </a>
                    </div>

                    {/* <p className="small-note">
                        <strong>Note:</strong> Set Drive links to{" "}
                        <em>Anyone with the link → View</em>. Mask Aadhaar number where
                        possible.
                    </p> */}

                    {/* Extra Details Link */}
                    <div className="more-details">
  <p className="helper-text">
   <i>Need full guidance?  <b>Check the Teacher Guide</b></i>
    <a href="/teacher" className="btn info" aria-label="View complete teacher details">
      <FaInfoCircle /> Explore Teacher Guide
    </a>
  </p>
</div>

                </div>
            </div>
        </section>
    );
};

export default TeacherMiniSection;
